module.exports = __webpack_public_path__ + "static/media/border.acf8ca12.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/border.png
// module id = 647
// module chunks = 6